import {
  ScrollspyNav,
  ScrollspyNavItem,
  ScrollspyNavItemPressable,
  ScrollspyScrollView,
  ScrollspyTarget,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const Scrollspy = {
  ScrollView: ScrollspyScrollView,
  Target: ScrollspyTarget,
  Nav: ScrollspyNav,
  NavItem: ScrollspyNavItem,
  NavItemPressable: ScrollspyNavItemPressable,
};
